define([
	"dojo/_base/declare",
	"csi/heading/String"
], function(declare,String) {

	return declare(String, {
		bBaseRenderer: true,

		getQuerySpec: function(/*Context*/ctx, /*Heading*/h, /*Spec*/spec) {
			// summary: filtering not supported
			return null;
		},

		reserveContext: function(/*Context*/ctx, /*Heading*/h) {
			// summary: apply any renderer-specific changes to context before use
			var act = ctx.view.getViewNode();
			var master = ctx.cache.getNode(act.Master);
			ctx.pushParams();
			ctx.keyValue = master.Index;
			ctx.setReadOnly(false);
			this.inherited(arguments);
		},

		releaseContext: function(/*Context*/ctx, /*Heading*/h) {
			// summary: pop context applied above
			ctx.keyValue = null;
			ctx.pop();
			this.inherited(arguments);
		}
	});
});